import { add as dateAdd, differenceInMonths } from "date-fns";
import { cdkSubscriptionStatuses } from "../constants";
import { isAdmin } from "../services/accountService";

export const cdkTerms = {
  freeTrial: "Free Trial",
  threeMonthTerm: "3 Month Term",
  monthly: "Monthly Subscription",
};

//right now we just check if cdkStatus is null (which indicates they have never been subscribed before)
//so basically, they are only eligible if they have had no previous subscription
export function determineEligibleForCDKTrial(cdkStatus) {
  if (cdkStatus === null) {
    return true;
  } else return false;
}

//expects history to be sorted in descending order
//i.e. from most recent entry at index 0 to oldest entry at last index
//returns date object
export function determineSubscriptionStartDate(
  history,
  isPreSorted = true,
  dateDescriptor = "descriptionDate",
  statusDescriptor = "subscriptionStatus"
) {
  if (history.length <= 1) {
    //if history.length is 0, they have never subscribed.
    //if history.length is 1, they are pending approval to start the subscription
    return null;
  }
  let historyCopy = [...history];
  if (!isPreSorted) {
    historyCopy.sort((a, b) => {
      return -1 * a[dateDescriptor].localeCompare(b[dateDescriptor]);
    });
  }
  let dateStarted =
    history[0][statusDescriptor] === cdkSubscriptionStatuses.cancellationPending
      ? new Date(history[1][dateDescriptor])
      : history[0][statusDescriptor] === cdkSubscriptionStatuses.active
      ? new Date(history[0][dateDescriptor])
      : null;
  return dateStarted;
}

// made this a function so we can switch between month difference being between calender months (i.e. jan 15->feb 15) vs 30 day increments quickly (but make sure it is being used everywhere the switch is needed)
export const calculateDifferenceInMonths = (currentDate, startDate) => {
  return differenceInMonths(currentDate, startDate);
};
export const determineCDKTermByMonthsPassed = (monthsPassed) => {
  if (monthsPassed === 0) {
    return cdkTerms.freeTrial;
  } else if (monthsPassed > 0 && monthsPassed <= 3) {
    return isAdmin() ? "3 Month Locked In Period" : cdkTerms.threeMonthTerm;
  } else {
    return cdkTerms.monthly;
  }
};
export const determineCDKTermByStartDate = (startDate) => {
  const monthsPassed = differenceInMonths(new Date(), startDate);
  return determineCDKTermByMonthsPassed(monthsPassed);
};

//takes in date the client started their subscription
//returns date when their current term would end.
export const determineEndOfCDKTerm = (dateStarted, monthsPassed) => {
  //If they are in their free trial, their term ends 1 month since they started
  if (monthsPassed > 0 && monthsPassed <= 3) {
    return dateAdd(dateStarted, { months: 4 });
  } else {
    return dateAdd(dateStarted, { months: monthsPassed + 1 });
  }
};
// const termsPassedBy30DayIncrements = daysSince / 30; // I am going with calendar dates for the months everywhere. For Cancellations we finalize after 30 days instead of calendar month.
//if they cancelled within their free trial, do we cancel immediately or do we continue service for until 1 calendar month from free trial start date has passed?
//if they cancelled within their three month term, we finalize cancellation at the end of their three month term or 30 days from when they requested cancellation, whichever is greater.
//if they cancel in a normal 1 month term, we finalize cancellation 30 days after they requested cancellation
export const determineFinalizeCancellationEndDate = (
  dateRequestedCancellation,
  dateStarted,
  currentTerm
) => {
  if (currentTerm === cdkTerms.freeTrial) {
    return dateAdd(dateStarted, { months: 1 });
  } else if (currentTerm === cdkTerms.threeMonthTerm) {
    return Math.max(
      dateAdd(dateStarted, { months: 4 }),
      dateAdd(dateRequestedCancellation, { days: 30 })
    );
  } else {
    return dateAdd(dateRequestedCancellation, { days: 30 });
  }
};
